var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72222 4.4C2.72222 3.23305 3.17292 2.11389 3.97515 1.28873C4.77739 0.46357 5.86546 0 7 0C8.13454 0 9.22261 0.46357 10.0248 1.28873C10.8271 2.11389 11.2778 3.23305 11.2778 4.4C11.2778 5.56695 10.8271 6.68611 10.0248 7.51127C9.22261 8.33643 8.13454 8.8 7 8.8C5.86546 8.8 4.77739 8.33643 3.97515 7.51127C3.17292 6.68611 2.72222 5.56695 2.72222 4.4ZM0 13.6C0 12.5391 0.409721 11.5217 1.13903 10.7716C1.86834 10.0214 2.85749 9.6 3.88889 9.6H10.1111C11.1425 9.6 12.1317 10.0214 12.861 10.7716C13.5903 11.5217 14 12.5391 14 13.6V16H0V13.6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.51339632df795e42ffebdc0878667c3d.svg";
export { ForwardRef as ReactComponent };